import { useState, useEffect } from 'react'

import Api from 'services/api'

const useCurrentDeviceState = (deviceId) => {
  const [currentDeviceState, setCurrentDeviceState] = useState(null)
  const [isCurrentDeviceStateLoaded, setIsCurrentDeviceStateLoaded] = useState(false)

  useEffect(() => {
    setCurrentDeviceState(null)
    setIsCurrentDeviceStateLoaded(false)

    Api.DeviceAggregator.getCurrentDeviceState(deviceId)
      .then((res) => {
        if (res) {
          setIsCurrentDeviceStateLoaded(true)
          setCurrentDeviceState(res)
        }
      })
      .catch(() => {
        setIsCurrentDeviceStateLoaded(true)
      })
  }, [deviceId])

  return { currentDeviceState, isCurrentDeviceStateLoaded }
}

export default useCurrentDeviceState
